/** Query on /login from account emails — forces sign-out before showing the form. */
export const LOGIN_SWITCH_ACCOUNT_QUERY = 'switch';

export const ROUTES = {
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  revealCredential: '/reveal-credential',
  changePassword: '/change-password',
  profile: '/profile',
  home: '/',
  dashboard: (role, tab) =>
    tab
      ? `/dashboard/${encodeURIComponent(role)}/${encodeURIComponent(tab)}`
      : `/dashboard/${encodeURIComponent(role)}`,
};

export const ADMIN_TABS = [
  'users',
  'batches',
  'tags',
  'books',
  'lessons',
  'elements',
  'exercises',
  'question-bank',
  'exercise-bank',
  'pending-evaluations',
  'audit-logs',
  'reports',
  'automation',
  'fees',
];

export const CREATOR_TABS = [
  'books',
  'lessons',
  'elements',
  'exercises',
  'question-bank',
  'exercise-bank',
  'evaluation',
  'users',
  'reports',
];

export const STUDENT_TABS = ['books', 'reports'];
export const PARENT_TABS = ['books', 'students', 'reports'];

export const DASHBOARD_ROLES = ['super-admin', 'content-creator', 'student', 'parent'];
